




































import { Component, Vue, Prop } from 'vue-property-decorator';
import OftenUseFileList from '@/components/storage/storageList/useFileList/lists/OftenUseFileList.vue';
import AddFolderModal from '@/components/storage/modals/AddFolderModal.vue';
import AddFileModal from '@/components/storage/modals/AddFileModal.vue';
import StorageSubHeader from '@/components/storage/storageList/storageSubHeader.vue';
import RecentUsedFileList from '@/components/storage/storageList/useFileList/lists/RecentUsedFileList.vue';
import RecentUpdateFileList from '@/components/storage/storageList/useFileList/lists/RecentUpdateFileList.vue';

@Component({
  components: {
    OftenUseFileList,
    AddFolderModal,
    AddFileModal,
    StorageSubHeader,
    RecentUsedFileList,
    RecentUpdateFileList
  },
})
export default class UseFileListBase extends Vue {
  private files: Array<{ name: string; type: string; src: string; }> = [
    {
      name: '定例資料1.png',
      type: 'png',
      src: 'https://sozai.site/wp-content/uploads/2016/11/Screen-Shot-2016-11-06-at-17.34.57-1024x646.png'
    },
    {
      name: '定例資料2.png',
      type: 'png',
      src: 'https://sozai.site/wp-content/uploads/2016/11/Screen-Shot-2016-11-06-at-17.34.57-1024x646.png'
    },
    {
      name: '定例資料3.png',
      type: 'png',
      src: 'https://sozai.site/wp-content/uploads/2016/11/Screen-Shot-2016-11-06-at-17.34.57-1024x646.png'
    },
    {
      name: '定例資料4.png',
      type: 'png',
      src: 'https://sozai.site/wp-content/uploads/2016/11/Screen-Shot-2016-11-06-at-17.34.57-1024x646.png'
    },
    {
      name: '定例資料5.png',
      type: 'png',
      src: 'https://sozai.site/wp-content/uploads/2016/11/Screen-Shot-2016-11-06-at-17.34.57-1024x646.png'
    },
    {
      name: '定例資料6.png',
      type: 'png',
      src: 'https://sozai.site/wp-content/uploads/2016/11/Screen-Shot-2016-11-06-at-17.34.57-1024x646.png'
    },
    {
      name: '定例資料7.png',
      type: 'png',
      src: 'https://sozai.site/wp-content/uploads/2016/11/Screen-Shot-2016-11-06-at-17.34.57-1024x646.png'
    },
    {
      name: '定例資料8.png',
      type: 'png',
      src: 'https://sozai.site/wp-content/uploads/2016/11/Screen-Shot-2016-11-06-at-17.34.57-1024x646.png'
    },
  ];

  private isOpenAddFolderModal: boolean = false;
  private isOpenAddFileModal: boolean = false;
  private isSearchBarFocus: boolean = false;
  private isShowFilePreviewModal: boolean = false;
  private file: object = {};

  private SearchBarFocusBackground(): string {
    return '#edf4ff';
  }

  private closeAddFileModal(): void {
    this.isOpenAddFileModal = false;
  }

  private closeAddFolderModal(): void {
    this.isOpenAddFolderModal = false;
  }

  private switchShowFilePreviewModal(file: object): void {
    this.isShowFilePreviewModal = !this.isShowFilePreviewModal;
    this.file = file;
  }
}
